/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */
import React from 'react';

import { connect } from 'react-redux';
import TRP from 'components/shared/TRP/TRP';
import { footerLinks } from 'services/Externals';
import { bool } from 'prop-types';
import { showStopTransferBoxInfo } from 'state/linkedBankAccounts/LinkedBankAccountsSelectors';

const StopTransferBoxInfo = ({ showStopTransferBoxInfo }) =>
  showStopTransferBoxInfo ? (
    <div className="info-box">
      <h2>Add Bank Account</h2>
      <p>
        <a
          href={footerLinks.contactUsUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          <b>Contact us</b>
        </a>
        &nbsp;to address the Stop Transfer on your <TRP /> account(s). You can
        add new bank accounts once the Stop Transfer has been removed
      </p>
    </div>
  ) : null;

StopTransferBoxInfo.propTypes = {
  showStopTransferBoxInfo: bool
};

StopTransferBoxInfo.defaultProps = {
  showStopTransferBoxInfo: false
};

const mapStateToProps = (state) => ({
  showStopTransferBoxInfo: showStopTransferBoxInfo(state)
});

export default connect(mapStateToProps)(StopTransferBoxInfo);
